import { render } from "./S173107.vue?vue&type=template&id=908bd04c"
const script = {}
script.render = render

export default script